import React, { useEffect, useState } from "react";
import services from "../../services";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { MdDeleteOutline, MdEdit } from "react-icons/md";
import { MdDetails } from "react-icons/md";
import ComposeEmail from "../../common/ComposeModal";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import ResponsivePagination from "react-responsive-pagination";
import { Tooltip } from "react-tooltip";
import axios from "axios";

const ShowAllMail = ({ gmailUsers, ActionPage }) => {
    const [loading, setLoading] = useState(false);
    const [allDraft, setAllDraft] = useState();
    const [ModalOpen, setModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [gmailMessageId, setGmailMessageId] = useState("")
    const [mailPage, setMailPage] = useState(ActionPage || 1);
    const [totalCount, setTotalCount] = useState(0);
    const [totalMails, setTotalMails] = useState(0)
    const [selectedGmailUser, setSelectedGmailUser] = useState(gmailUsers?.[0]?.value);
    const [selectedMailType, setSelectedMailType] = useState("All Mails");
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");


    const navigate = useNavigate();

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
            setMailPage(1);
        }, 500);

        return () => clearTimeout(handler);
    }, [search]);

    const getDraft = async (signal) => {
        setLoading(true);
        try {
            const isSearching = !!debouncedSearch;
            const response = await services.email.GET_ALL_MAILS(
                selectedGmailUser,
                mailPage,
                10,
                debouncedSearch,
                signal,
                isSearching // pass falsepagination as true if searching
            );
            setTotalCount(response?.data?.pagination?.totalPages);
            setTotalMails(response?.data?.pagination?.totalRecords);
            setAllDraft(response?.data?.data);
            setLoading(false);
        } catch (error) {
            if (error.name === 'AbortError' || error.name === 'CanceledError') {
                console.log('Request canceled');
            } else {
                console.error(error);
                setLoading(false);
            }
        }
    };

    /*   useEffect(() => {
          const controller = new AbortController();
          if (selectedGmailUser) {
              getDraft(controller.signal);
          }
          return () => controller.abort();
      }, [mailPage, gmailUsers, selectedGmailUser, debouncedSearch]); */

    async function fetchSentEmails(page = 1, limit = 10, selectedGmailUser, debouncedSearch) {
        setLoading(true);
        try {
            const res = await services.email.GET_SENT_MAIL(page, limit, selectedGmailUser, debouncedSearch);
            setAllDraft(res?.data?.data);
            setTotalCount(res?.data?.pagination?.totalPages);
            setTotalMails(res?.data?.pagination?.totalCount);
            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    }
    useEffect(() => {
        const controller = new AbortController();

        if (!selectedGmailUser) return;

        if (selectedMailType === "Sent") {
            fetchSentEmails(
                mailPage,
                10,
                selectedGmailUser,
                debouncedSearch,
                controller.signal
            );
        } else {
            getDraft(
                controller.signal,
                selectedGmailUser,
                debouncedSearch,
                mailPage
            );
        }

        return () => controller.abort();
    }, [
        selectedMailType,
        selectedGmailUser,
        mailPage,
        debouncedSearch
    ]);





    const handleEditClick = async (item) => {

        navigate(`/detail/${item?.id}`, {
            state: {
                selectedMail: item,
                deadlineDate: item?.deadlineDate,
                taskID: item.id,
                AllMail: true,
                type: 'Gmail',
                currentTask: item,
                boardId: item?.boardId,
                isMember: item?.isMember,
                parentOrigin: item?.parentOrigin,
                AllMailPage: mailPage
            },
        });
    };
    const updateStatusTaskMessage = async (gmailMessageId, status) => {
        try {
            
            const data = {
                messageRead: status,
            };
            
            const response = await services.email.EMAIL_UPDATEMESSAGE_READ(gmailMessageId, data);
            
            // Update local state to immediately reflect the change
            if (allDraft && Array.isArray(allDraft)) {
                const updatedDrafts = allDraft.map(draft => 
                    draft.gmailMessageId === gmailMessageId 
                        ? { ...draft, messageRead: status }
                        : draft
                );
                setAllDraft(updatedDrafts);
            }
            
            // Refresh the mails list based on current mail type
            if (selectedMailType === "Sent") {
                await fetchSentEmails(mailPage, 10, selectedGmailUser, debouncedSearch);
            } else {
                const controller = new AbortController();
                await getDraft(controller.signal);
            }
        } catch (error) {
            console.error('Error updating message read status:', error);
            toast.error('Failed to update message status');
        }
    };
    const dropDown = ["All Mails", "Sent"]
    return (
        <div className="h-[88vh] flex flex-col">
            {loading ? (
                <div className="flex-1 flex items-center justify-center text-[#8696a0] text-lg">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="flex-1 overflow-y-auto">
                    <div className="">
                        <div className="flex items-center justify-between px-4 py-2 border-gray-200 bg-gray-50 rounded-t-lg">
                            <input
                                type="text"
                                placeholder="Search Mail..."
                                className="search-input"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <div className="flex space-x-5">
                                <span className="text-sm text-gray-500">
                                    <select
                                        className="block w-full px-3 py-2 border rounded-md text-sm"
                                        onChange={(e) => { setSelectedGmailUser(e.target.value); setMailPage(1); setSearch("") }}
                                        value={selectedGmailUser}
                                    >
                                        {gmailUsers?.map((user) => (
                                            <option key={user.value} value={user.value}>
                                                {user.label}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                                <span className="text-sm text-gray-500">
                                    <select
                                        className="block w-full px-3 py-2 border rounded-md text-sm"
                                        value={selectedMailType}
                                        onChange={(e) => { setSelectedMailType(e.target.value); setSearch(""); setMailPage(1); }}
                                    >
                                        {dropDown?.map((option) => (
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </select>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="mx-auto mt-6 border border-gray-200 rounded-lg shadow-sm bg-white">
                        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-50 rounded-t-lg">
                            <h2 className="text-lg font-semibold text-gray-700">Mails</h2>
                            <span className="text-sm text-gray-500">
                                {totalMails} Mails
                            </span>
                        </div>

                        <div className="divide-y divide-gray-200 bg-[#f2f6fc]">
                            {allDraft &&
                                allDraft.map((draft) => {
                                    const allowedLabels = ["inbox", "draft", "sent"];
                                    const email = draft.sentTo || "";
                                    const username = email.split("@")[0];
                                    const showTooltip = username.length > 25;
                                    const escapeHtml = (str = "") =>
                                        str
                                            .replace(/&/g, "&amp;")
                                            .replace(/</g, "&lt;")
                                            .replace(/>/g, "&gt;");

                                    const sentByMail = escapeHtml(draft?.sender || draft?.sentBy);
                                    const sentToMail = escapeHtml(draft?.receiver || draft?.sentTo);

                                    return (<div
                                        key={draft.id}
                                        className="flex items-center justify-between px-4 py-3 hover:bg-gray-50 group cursor-pointer"
                                    >
                                        <div className="flex items-center space-x-10">
                                            <div className="flex-shrink-0 w-[200px] max-w-[350px] overflow-hidden truncate px-2">
                                                <span
                                                    className={`cursor-pointer truncate max-w-[200px] ${draft.messageRead == "unread" ? '!font-bold' : '!font-normal'}`}
                                                    data-tooltip-id="email-tooltip"
                                                    data-tooltip-html={`
            <div style="display:flex; flex-direction:column; gap:4px;">
                <div>
                    <strong>Sent By:</strong>
                    <span style="margin-left:6px;">${sentByMail}</span>
                </div>
                <div>
                    <strong>Sent To:</strong>
                    <span style="margin-left:6px;">${sentToMail}</span>
                </div>
            </div>
        `}
                                                >
                                                    {draft.name}
                                                </span>

                                                <Tooltip
                                                    id="email-tooltip"
                                                    place="top"
                                                    style={{
                                                        backgroundColor: "#fff",
                                                        color: "#1f2937",
                                                        border: "1px solid #e5e7eb",
                                                        fontSize: "12px",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.08)"

                                                    }}
                                                />
                                            </div>

                                            <span className="text-sm text-gray-700">
                                                {draft?.SubEmails?.length > 0 ? draft?.SubEmails?.length : ''}
                                            </span>

                                            <span className="flex flex-wrap gap-1">
                                                {draft.labels
                                                    ?.toLowerCase()
                                                    .split(",")
                                                    .filter(label => allowedLabels.includes(label))
                                                    .map(label => (
                                                        <span
                                                            key={label}
                                                            className={`px-2 py-0.5 rounded-sm text-xs font-medium  bg-gray-200 text-gray-700`}
                                                        >
                                                            {label.charAt(0).toUpperCase() + label.slice(1)}
                                                        </span>
                                                    ))}
                                            </span>




                                            <span
                                                className={`text-black-700 max-w-[600px] truncate ${draft.messageRead == "unread" ? '!font-bold' : '!font-normal'}`}
                                                data-tooltip-id="subject-tooltip"
                                                data-tooltip-content={draft.subject}
                                                onMouseEnter={(e) => {
                                                    const target = e.currentTarget;
                                                    if (target.scrollWidth <= target.clientWidth) {
                                                        target.removeAttribute('data-tooltip-id');
                                                    } else {
                                                        target.setAttribute('data-tooltip-id', 'subject-tooltip');
                                                    }
                                                }}
                                            >
                                                {draft.subject}
                                            </span>
                                        </div>

                                        <div className="flex items-center space-x-3">
                                            <span className="text-sm text-black-500 group-hover:hidden">
                                                {draft?.isTaskCreated && (
                                                    <span className="text-gray-600 font-[4px]">
                                                        Board &nbsp; - {draft?.Tasks?.[0]?.Board?.boardName}
                                                        {draft?.Tasks?.[0]?.BoardList?.coloum && (
                                                            <>
                                                                {" "}→{" "}
                                                                {draft?.Tasks?.[0]?.BoardList?.coloum}
                                                            </>
                                                        )}
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                    </span>
                                                )}
                                                {moment(draft.createdAtEmail).format("MMM D,h:mm ")}
                                            </span>

                                            <div className="hidden group-hover:flex space-x-2">
                                                {draft?.isTaskCreated && (
                                                    <span className="text-gray-600 font-[8px]">  Board &nbsp; -
                                                        {draft?.Tasks?.[0]?.Board?.boardName}
                                                        {draft?.Tasks?.[0]?.BoardList?.coloum && (
                                                            <>
                                                                {" "}→{" "}
                                                                {draft?.Tasks?.[0]?.BoardList?.coloum}
                                                            </>
                                                        )}
                                                        &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;
                                                    </span>
                                                )}
                                                <button className="p-1 rounded hover:bg-gray-200">

                                                    <MdDetails
                                                        fontSize={20}
                                                        onClick={() => {
                                                            handleEditClick(draft)
                                                            updateStatusTaskMessage(draft.gmailMessageId, 'read')
                                                        }}
                                                    />

                                                </button>

                                            </div>
                                        </div>
                                    </div>
                                    )
                                })}
                        </div>
                    </div>
                    <div>
                        <div style={{ marginTop: "20px" }}>
                            <ResponsivePagination
                                current={mailPage}
                                total={totalCount}
                                onPageChange={setMailPage}
                            />
                        </div>
                    </div>
                </div>
            )
            }
            <Tooltip id="subject-tooltip" placement="top" />
        </div >
    );
};

export default ShowAllMail;
